var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeneficioEducation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.206,
    height: 122.819,
    viewBox: "0 0 123.206 122.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464.3,463.426a3.452,3.452,0,0,0-3.454-3.445H406.962a3.45,3.45,0,0,0,0,6.9h53.882A3.459,3.459,0,0,0,464.3,463.426Z",
    transform: "translate(-372.301 -433.11)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M407.746,461.313a3.45,3.45,0,1,0,0,6.9h40.232a3.45,3.45,0,0,0,0-6.9Z",
    transform: "translate(-366.255 -422.705)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M418.276,464.072a12.763,12.763,0,1,0,12.768,12.768A12.78,12.78,0,0,0,418.276,464.072Zm5.868,12.768a5.864,5.864,0,1,1-5.868-5.868A5.865,5.865,0,0,1,424.144,476.84Z",
    transform: "translate(-356.678 -401.153)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M456.733,496.64a23.244,23.244,0,1,0-28.936,11.2l-5.507,11.684-.705-2.864a3.444,3.444,0,0,0-4.749-2.335l-2.9,1.286,4.934-10.133-6.2-3.022-9.076,18.653a3.455,3.455,0,0,0,4.511,4.661l7.763-3.462,2.035,8.318a3.475,3.475,0,0,0,3,2.617c.114.008.238.017.353.017a3.471,3.471,0,0,0,3.119-1.983l10.353-21.967c.432.018.854.062,1.286.062s.864-.044,1.3-.062l10.353,21.967a3.471,3.471,0,0,0,3.119,1.983c.114,0,.238-.009.353-.017a3.475,3.475,0,0,0,3-2.617l2.035-8.318,7.772,3.462a3.449,3.449,0,0,0,4.512-4.643Zm-4.362-10.512a16.35,16.35,0,1,1-16.354-16.345A16.369,16.369,0,0,1,452.371,486.128ZM452.08,502.9l6.106,12.75-2.978-1.322a3.444,3.444,0,0,0-4.749,2.335l-.7,2.864-5.5-11.684A23.331,23.331,0,0,0,452.08,502.9Z",
    transform: "translate(-374.42 -410.441)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M399.974,456.931v92.323H434.5v-6.9H406.874V463.831H516.28v78.524H489.254v6.9H523.18V456.931Z",
    transform: "translate(-399.974 -456.931)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M419.986,458.091h-18.8V476.9h6.9V464.99h11.9Z",
    transform: "translate(-390.547 -447.878)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M429.423,476.9V458.091H410.615v6.9h11.909V476.9Z",
    transform: "translate(-316.852 -447.878)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M410.615,482.923h18.808V464.116h-6.9v11.908H410.615Z",
    transform: "translate(-316.852 -400.813)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M401.181,464.116v18.807h18.8v-6.9h-11.9V464.116Z",
    transform: "translate(-390.547 -400.813)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficioEducation);
export default __webpack_public_path__ + "static/media/beneficio-education.75c814fc1ebd3dfac49fd2b8e4b92e75.svg";
export { ForwardRef as ReactComponent };